import React, { useState } from "react";

import "../../assets/css/candidate-tracking.css";

import NavBar from "../../components/general/NavBarApp.jsx";
import CandidateTrackingDashboard from "../../components/candidate/candidate-tracking-dashboard";
import NavBarApp from "../../components/general/NavBarApp.jsx";

const CandidateTracking = () => {
  return (
    <div className="main">
      <NavBarApp userType="entreprise" />
      <CandidateTrackingDashboard />
    </div>
  );
};

export default CandidateTracking;
